"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkYYYYMMDD = checkYYYYMMDD;
exports.checkDDMMYYYY = checkDDMMYYYY;
exports.formatToDDMMYYYY = formatToDDMMYYYY;
exports.formatToYYYYMMDD = formatToYYYYMMDD;
exports.formatTo0101YYYY = formatTo0101YYYY;
exports.getYearFromDDMMYYYY = getYearFromDDMMYYYY;
exports.getDateFromDDMMYYYY = getDateFromDDMMYYYY;
exports.getDateStingFromDate = getDateStingFromDate;
exports.convertFechaInicio = convertFechaInicio;
exports.convertFechaFin = convertFechaFin;
exports.showFecha = showFecha;
exports.compararPeriodos = compararPeriodos;
exports.estaDentroDelPeriodo = estaDentroDelPeriodo;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.string.replace.js");

var _slicedToArray2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/slicedToArray"));

/**
 * Funcion que chequea que el string tenga el formato **YYYY-MM-DD**
 * @param date {string}
 * @returns  {boolean} devuelve true si el string tiene el formato correcto, sino false
 */
function checkYYYYMMDD(date) {
  var userKeyRegExp = /(19|20)\d\d(-)\d\d(-)\d\d/;
  return userKeyRegExp.test(date);
}
/**
 * Funcion que chequea que el string tenga el formato **DD-MM-YYYY**
 * @param date {string}
 * @returns  {boolean} devuelve true si el string tiene el formato correcto, sino false
 */


function checkDDMMYYYY(date) {
  var userKeyRegExp = /\d\d(-)\d\d(-)(19|20)\d\d/;
  return userKeyRegExp.test(date);
}
/**
 * Funcion que recibe una fecha formateada YYYY-MM-DD y la retorna DD-MM-YYYY
 * @param date {string} - La fecha debe venir com string con formato **YYYY-MM-DD**
 * @returns La misma fecha pero con formato **DD-MM-YYYY** si está vacía o no tiene bien el formato retorna **null**
 */


function formatToDDMMYYYY(date) {
  if (date && checkYYYYMMDD(date)) {
    var _date$split = date.split('-'),
        _date$split2 = (0, _slicedToArray2.default)(_date$split, 3),
        year = _date$split2[0],
        month = _date$split2[1],
        day = _date$split2[2];

    return "".concat(day, "-").concat(month, "-").concat(year);
  }

  return null;
}
/**
 * Funcion que recibe una fecha formateada DD-MM-YYYY y la retorna  YYYY-MM-DD
 * @param date {string} - La fecha debe venir com string con formato **DD-MM-YYYY**
 * @returns La misma fecha pero con formato **YYYY-MM-DD**
 */


function formatToYYYYMMDD(date) {
  if (date && checkDDMMYYYY(date)) {
    var _date$split3 = date.split('-'),
        _date$split4 = (0, _slicedToArray2.default)(_date$split3, 3),
        day = _date$split4[0],
        month = _date$split4[1],
        year = _date$split4[2];

    return "".concat(year, "-").concat(month, "-").concat(day);
  }

  return null;
}
/**
 * Funcion que recibe un año y lo devuelve como fecha
 * @param year {number} - El año debe venir como número entre 1900 y 2100
 * @returns Devuelve como fecha el año con el formato  **01-01-${year}** o **null**
 */


function formatTo0101YYYY(year) {
  if (year && year >= 1900 && year < 2100) {
    return "01-01-".concat(year);
  }

  return null;
}
/**
 * Funcion que recibe una fecha formateada DD-MM-YYYY y la retorna  YYYY
 * @param date {string} - La fecha debe venir com string con formato **DD-MM-YYYY**
 * @returns El año como number o 0 si no cumple las precondiciones
 */


function getYearFromDDMMYYYY(date) {
  if (date && checkDDMMYYYY(date)) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _date$split5 = date.split('-'),
        _date$split6 = (0, _slicedToArray2.default)(_date$split5, 3),
        day = _date$split6[0],
        month = _date$split6[1],
        year = _date$split6[2];

    return +year; // se convierte a numero
  }

  return 0;
}
/**
 * Funcion que convierte una fecha de string a Date
 * @param date {string} - La fecha debe venir com string con formato **DD-MM-YYYY**
 * @returns Un objeto date con utc -3 y el time en 0
 */


function getDateFromDDMMYYYY(date) {
  var _date$split7 = date.split('-'),
      _date$split8 = (0, _slicedToArray2.default)(_date$split7, 3),
      day = _date$split8[0],
      month = _date$split8[1],
      year = _date$split8[2];

  return new Date("".concat(year, "-").concat(month, "-").concat(day, "T00:00:00.000-03:00")); // se convierte a Date
}
/**
 * Funcion que convierte una fecha de Date a string
 * @param date {Date}
 * @returns un string con formato  **DD-MM-YYYY**
 */


function getDateStingFromDate(d) {
  return [d.getDate(), d.getMonth() + 1, d.getFullYear()].map(function (n) {
    return n < 10 ? "0".concat(n) : "".concat(n);
  }).join('-');
}
/**
 * Funcion que convierte una string a Date
 * @param date {string}  **DD-MM-YYYY**
 * @returns {Date} - el date será del día de la fecha con utc -3 y primer segundo del día
 */


function convertFechaInicio(date) {
  return new Date(formatToYYYYMMDD(date) + 'T00:00:00.000-03:00');
}
/**
 * Funcion que convierte una string a Date
 * @param date {string}  **DD-MM-YYYY**
 * @returns {Date} - el date será del día de la fecha con utc -3 y último segundo del día
 */


function convertFechaFin(date) {
  return new Date(formatToYYYYMMDD(date) + 'T23:59:59.000-03:00');
}
/**
 * Funcion que reemplaza los guiones por barras
 * @param date {string}
 * @returns {Date} - el date será del día de la fecha con utc -3
 */


function showFecha(date) {
  return date.replace(/-/g, '/');
}
/**
 * Funcion que informa si una fecha está dentro de un período
 * @param fechaInicio {Date} cota inferior del período
 * @param fecha {Date} fecha a comparar
 * @param fechaFin {Date} cota superioro del período
 * @returns {boolean} - devuelve true si fecha pertenece al conjunto [fechaInicio, fechaFin]
 */


function compararPeriodos(fechaInicio, fecha, fechaFin) {
  return fechaInicio <= fecha && fechaFin >= fecha;
}
/**
 * Funcion que informa si una en este momento se está dentro de un período
 * @param fechaInicial {string} cota inferior del período (formato: **DD-MM-YYYY** )
 * @param fechaFinal {string} cota superioro del período
 * @returns {boolean} - Devuelve true si el día de hoy pertenece al conjunto [fechaInicial, fechaFinal]
 */


function estaDentroDelPeriodo(fechaInicial, fechaFinal) {
  var fechaHoy = new Date();
  var fechaInicio = convertFechaInicio(fechaInicial);
  var fechaFin = convertFechaFin(fechaFinal);
  return compararPeriodos(fechaInicio, fechaHoy, fechaFin);
}